window.addEventListener('DOMContentLoaded', (event) => {

    $('#whenWeAreTogether').owlCarousel({
        items: 1,
        loop: false,
        nav: false,
    });

    $('#togetherStoryNext').click(function () {
        $('#whenWeAreTogether').trigger('next.owl.carousel');
    });
    $('#togetherStoryPrev').click(function () {
        $('#whenWeAreTogether').trigger('prev.owl.carousel');
    });

});
